export interface ProcessStep {
  idx: string;
  title: string;
  body: string;
}

export function ProcessSteps({ steps }: { steps: ProcessStep[] }) {
  return (
    <ol className="m-0 grid list-none gap-6 p-0 md:grid-cols-2 lg:grid-cols-4">
      {steps.map((s) => (
        <li
          className="prose-card"
          key={s.idx}
          style={{
            padding: "28px 24px",
            background: "#ffffff",
            border: "1px solid rgba(0,47,167,0.12)",
            borderRadius: 4,
          }}
        >
          <div
            className="mono mb-5"
            style={{
              fontSize: 11,
              letterSpacing: "0.16em",
              color: "rgba(0,47,167,0.75)",
            }}
          >
            STEP {s.idx}
          </div>
          <h3
            style={{
              fontFamily: '"IBM Plex Sans", "IBM Plex Sans Fallback", sans-serif',
              fontWeight: 300,
              fontSize: 22,
              letterSpacing: "-0.01em",
              margin: 0,
              color: "#002FA7",
              lineHeight: 1.2,
            }}
          >
            {s.title}
          </h3>
          <p
            className="mt-3"
            style={{ color: "rgba(0,47,167,0.74)", fontSize: 14, lineHeight: 1.55 }}
          >
            {s.body}
          </p>
        </li>
      ))}
    </ol>
  );
}
